import { Injectable } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class EventLogStateService {
  private readonly KEY = 'eventLogFilter';
 
  setFilter(plantId: string, trainId: string): void {
    sessionStorage.setItem(this.KEY, JSON.stringify({ plantId, trainId }));
  }
 
  getFilter(): any {
    const saved = sessionStorage.getItem(this.KEY);
    return saved ? JSON.parse(saved) : {};
  }
 
  clearFilter(): void {
    sessionStorage.removeItem(this.KEY);
  }
}
 